import React from 'react'
import { FormControl } from 'react-bootstrap'
import './AdminInput.scss'

export default function Input(props){
    return (
        <FormControl {...props}  className={`form-control-input ${props?.className|| ""}`} />

    )
}